import PageLayout from "../../layouts/PageLayout.tsx";
import StatCard from "../../components/card/StatCard.tsx";
import CardActions from "../../components/card/CardActions.tsx";
import RolesTables from "../../components/table/RolesTables.tsx";
import ContractAddressTables from "../../components/table/ContractAddressTables.tsx";
import { useNavigate } from "react-router";
import { Card, SubCard } from "../../components/card/Card.tsx";
import { useQuery } from "@tanstack/react-query";
import {
  type AddressBook,
  getAddressBook,
} from "../../repository/AddressBookRepository.ts";
import { getEscrowMetrics } from "../../repository/MetricsRepository.ts";
import {PlusIcon, ZapIcon, ZapOffIcon} from "lucide-react";
import {StaffGuard} from "../../guards/StaffGuard.tsx";

const Factory = () => {
  const navigate = useNavigate();

  const { data: addressBook, isLoading: isAddressBookLoading } = useQuery({
    queryFn: () => getAddressBook(),
    queryKey: ["address-book"],
  });

  const {
    data: escrowMetrics,
    isLoading: isEscrowMetricsLoading,
    isSuccess: isEscrowMetricsSuccess,
  } = useQuery({
    queryFn: () => getEscrowMetrics(),
    queryKey: ["escrow-metrics"],
  });

  return (
    <PageLayout breadcrumbs={[{ name: "Factory" }]}>
        <StaffGuard>
      <div className="flex flex-col gap-4">
        <Card title={"Metrics"}>
          <div className="grid grid-cols-3 gap-4">
            <StatCard
              isLoading={isEscrowMetricsLoading}
              title={"Total escrows created"}
              value={
                isEscrowMetricsSuccess ? escrowMetrics.totalEscrowsCreated : 0
              }
              icon={PlusIcon}
            ></StatCard>
            <StatCard
              isLoading={isEscrowMetricsLoading}
              title={"Successful exchanges"}
              value={
                isEscrowMetricsSuccess ? escrowMetrics.successfulExchanges : 0
              }
              icon={ZapIcon}
            ></StatCard>
            <StatCard
              isLoading={isEscrowMetricsLoading}
              title={"Failed exchanges"}
              value={isEscrowMetricsSuccess ? escrowMetrics.failedExchanges : 0}
              icon={ZapOffIcon}
            ></StatCard>
          </div>
        </Card>

        <Card title={"Actions"}>
          <div className="grid grid-cols-3 gap-4">
            <CardActions
              title={"Create a new escrow contract"}
              description={
                "Launch a new escrow contract between a seller and a buyer by defining the wallets, deposits, currency, and the conditions of the exchange."
              }
              buttonText={"Create"}
              onClick={() => navigate("/factory/new-escrow")}
            />
            <CardActions
              title={"Whitelist"}
              description={
                "Add or remove authorized ERC-20 tokens for transactions in escrow contracts. Only whitelisted tokens can be used to create new contracts."
              }
              buttonText={"Manage"}
              onClick={() => navigate("/factory/whitelist")}
            />
            <CardActions
              title={"Nicknames"}
              description={
                "Manage nicknames for addresses to easily identify addresses associated with your escrow contracts."
              }
              buttonText={"Manage"}
              onClick={() => navigate("/factory/nicknames")}
            />
          </div>
        </Card>

        <Card title={"Roles and Addresses"}>
          <div className="grid grid-cols-2 gap-4">
            <SubCard>
              <RolesTables
                isLoading={isAddressBookLoading}
                addressBook={addressBook as AddressBook}
              />
            </SubCard>
            <SubCard>
              <ContractAddressTables
                isLoading={isAddressBookLoading}
                addressBook={addressBook as AddressBook}
              />
            </SubCard>
          </div>
        </Card>
      </div>
        </StaffGuard>
    </PageLayout>
  );
};

export default Factory;
